import { render, staticRenderFns } from "./gabdlrz.vue?vue&type=template&id=ab9c226e&scoped=true&"
import script from "./gabdlrz.vue?vue&type=script&lang=js&"
export * from "./gabdlrz.vue?vue&type=script&lang=js&"
import style0 from "./gabdlrz.vue?vue&type=style&index=0&id=ab9c226e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9c226e",
  null
  
)

export default component.exports